// extracted by mini-css-extract-plugin
export default {"text":"EventDescription_text__ZCfJd"};